const GLOBAL_STYLES = {
  primaryColor: "#D32F2F",
  secondaryColor: "#212121",
  thirdColor: "#7E7D7D",
  fourthColor: "#FFFFFF",
};
export default GLOBAL_STYLES;
